import { z } from "zod";

type RuntimeConfig = Partial<Record<"VITE_SUPABASE_URL" | "VITE_SUPABASE_ANON_KEY" | "VITE_SITE_URL" | "VITE_APP_ENV", string>>;

const runtimeConfig =
  typeof window === "undefined"
    ? {}
    : ((window as typeof window & { __GUIDING_STARS_CONFIG__?: RuntimeConfig })
        .__GUIDING_STARS_CONFIG__ ?? {});

const optionalUrl = z.union([z.literal(""), z.url()]);
const envSchema = z.object({
  VITE_SUPABASE_URL: optionalUrl.default(""),
  VITE_SUPABASE_ANON_KEY: z.string().default(""),
  VITE_SITE_URL: optionalUrl.default("http://localhost:5173"),
  VITE_APP_ENV: z.enum(["development", "test", "production"]).default("development"),
});

export const env = envSchema.parse({ ...import.meta.env, ...runtimeConfig });
